import { clearSubscriptionCache } from "@/lib/billing/subscriptionCache";
import { queryClient } from "@/lib/utils/queryUtils";

/** Drop in-memory user data so the next sign-in cannot reuse another account. */
export const clearUserCaches = () => {
  void queryClient.cancelQueries();
  queryClient.clear();
  clearSubscriptionCache();
  void import("@/components/chat/attachment-cache").then((mod) => {
    mod.clearAttachmentCache();
  });
};
